<template>
  <div class="news">
    <div class="banner">
      <el-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/banner-news.jpg"
        mode="contain"
      ></el-image>
    </div>
    <div style="width: 100%; height: 16px"></div>
    <div class="list">
      <div class="list-left">
        <h1 style="text-align: left">新闻列表</h1>
        <tab3></tab3>
      </div>
      <div class="list-right">
        <!-- <h1 style="text-align: left">热门新闻TOP10</h1>
        <tab5></tab5> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    tab3: () => import("@/components/common/tab3"),
    // tab5: () => import("@/components/common/tab5"),
  },
  mounted() {
    window.scroll(0, 0);
   
  },
 
};
</script>

<style lang="less" scoped>
.news {
  width: 100%;
}
.banner {
  width: 100%;
  height: 545px;
  margin-top: 65px;
}
.list {
  width: 1200px;
  height: 100%;
  margin: auto;
  overflow: hidden;
}
.list-left {
  width: 70%;
  height: 100%;
  float: left;
  padding: 0 3%;
}
.list-right {
  width: 30%;
  height: 100%;
  float: left;
}
</style>